import { render } from "./waterSiloController.vue?vue&type=template&id=56524ee0&scoped=true"
import script from "./waterSiloController.vue?vue&type=script&lang=js"
export * from "./waterSiloController.vue?vue&type=script&lang=js"

import "./waterSiloController.vue?vue&type=style&index=0&id=56524ee0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56524ee0"]])

export default __exports__